import * as React from "react";

const TimeIcon = (props) => (
  <svg
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.03 22.059c6.09 0 11.029-4.938 11.029-11.03C22.059 4.938 17.12 0 11.029 0 4.938 0 0 4.938 0 11.03c0 6.09 4.938 11.029 11.03 11.029Z"
      fill="currentColor"
    />
    <path
      d="M9.926 5.515v7.72M17.647 13.235h-7.72"
      stroke="#1758FE"
      strokeWidth={1.103}
      strokeLinecap="round"
    />
  </svg>
);

export default TimeIcon;
